"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styles = require("./styles");

var _designLanguage = require("@doordash/design-language");

var _constants = require("./constants");

var _componentButton = require("@doordash/component-button");

var _componentListCell = _interopRequireDefault(require("@doordash/component-list-cell"));

var _componentSeparator = _interopRequireDefault(require("@doordash/component-separator"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _lodash = _interopRequireDefault(require("lodash.omit"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var NavBar = function NavBar(_ref) {
  var actions = _ref.actions,
      isRaised = _ref.isRaised,
      isSeparatorVisibleProp = _ref.isSeparatorVisible,
      maxNumberOfVisibleActions = _ref.maxNumberOfVisibleActions,
      navigationType = _ref.navigationType,
      noContentPadding = _ref.noContentPadding,
      onNavigationClick = _ref.onNavigationClick,
      onOverflowClick = _ref.onOverflowClick,
      parentTitle = _ref.parentTitle,
      subtext = _ref.subtext,
      strings = _ref.strings,
      textAlign = _ref.textAlign,
      title = _ref.title,
      titleSize = _ref.titleSize,
      shouldRenderTitleOnNewLine = _ref.shouldRenderTitleOnNewLine;
  var displaySubtext = parentTitle || subtext;
  var isSubtextFirst = !!(parentTitle && parentTitle.length);
  var displayTitleBelow = titleSize !== _constants.TitleSizes.Small;
  var isSquished = displayTitleBelow ? false : !!(parentTitle && parentTitle.length) || !!(subtext && subtext.length);
  var isSeparatorVisible = typeof isSeparatorVisibleProp === 'boolean' ? isSeparatorVisibleProp : displayTitleBelow ? shouldRenderTitleOnNewLine : !isRaised;
  return /*#__PURE__*/_react["default"].createElement(_styles.NavBarContainer, {
    isRaised: isRaised
  }, /*#__PURE__*/_react["default"].createElement(_componentListCell["default"], {
    iconStart: navigationType === _constants.NavigationTypes.None ? undefined : {
      type: navigationType.icon,
      onClick: onNavigationClick,
      accessibilityLabel: strings && strings.navigationButtonLabel || navigationType.accessibilityLabel
    },
    textAlign: textAlign,
    title: !displayTitleBelow && !shouldRenderTitleOnNewLine && /*#__PURE__*/_react["default"].createElement(_designLanguage.Text // `lineHeight` prop is set to ensure Navbar title
    // is vertically centered with the leading and/or
    // trailing navigation & action button(s)
    , {
      lineHeight: _designLanguage.Text.LineHeights['900'],
      styles: _designLanguage.Text.Styles.NavBarCollapsedTitle,
      textAlign: textAlign
    }, title),
    subtext: !displayTitleBelow && !shouldRenderTitleOnNewLine && /*#__PURE__*/_react["default"].createElement(_designLanguage.Text, {
      color: _designLanguage.Text.Colors.TextTertiary,
      styles: _designLanguage.Text.Styles.NavBarCollapsedSubtitle,
      textAlign: textAlign
    }, displaySubtext),
    isSubtextFirst: isSubtextFirst,
    isSquished: isSquished,
    isSeparatorVisible: false,
    renderAfterContent: actions && actions.length ? function () {
      return /*#__PURE__*/_react["default"].createElement(_styles.ActionsContainer, {
        style: {
          margin: isSquished ? '0 -8px 0 0' : '-8px -8px -8px 8px',
          alignSelf: 'center',
          display: 'flex',
          justifyContent: 'center',
          height: isSquished ? '100%' : 'auto'
        }
      }, actions.slice(0, maxNumberOfVisibleActions).map(function (action) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: action.accessibilityLabel,
          style: {
            flexShrink: 0
          }
        }, /*#__PURE__*/_react["default"].createElement(_componentButton.IconButton, action));
      }), actions.length > maxNumberOfVisibleActions && onOverflowClick && /*#__PURE__*/_react["default"].createElement("div", {
        key: "overflow",
        style: {
          flexShrink: 0
        }
      }, /*#__PURE__*/_react["default"].createElement(_componentButton.IconButton, {
        onClick: function onClick(event) {
          return onOverflowClick(actions.slice(maxNumberOfVisibleActions), event);
        },
        accessibilityLabel: "Other Actions",
        iconType: _componentButton.IconButton.IconTypes.MoreHorizontal
      })));
    } : undefined
  }), (displayTitleBelow || shouldRenderTitleOnNewLine) && /*#__PURE__*/_react["default"].createElement(_designLanguage.Inset, {
    isSquished: true,
    size: noContentPadding ? 0 : undefined,
    style: {
      marginTop: -_designLanguage.Inset.Sizes.Small
    }
  }, /*#__PURE__*/_react["default"].createElement(_designLanguage.StackChildren, {
    size: _designLanguage.StackChildren.Sizes.XxSmall
  }, isSubtextFirst && /*#__PURE__*/_react["default"].createElement(_designLanguage.Text, {
    color: _designLanguage.Text.Colors.TextTertiary,
    textAlign: textAlign,
    styles: shouldRenderTitleOnNewLine && !displayTitleBelow ? _designLanguage.Text.Styles.NavBarCollapsedSubtitle : _designLanguage.Text.Styles.NavBarExpandedSubtitle
  }, displaySubtext), /*#__PURE__*/_react["default"].createElement(_designLanguage.Text, {
    textAlign: textAlign,
    tag: "h2",
    styles: shouldRenderTitleOnNewLine && !displayTitleBelow ? _designLanguage.Text.Styles.NavBarCollapsedTitle : _designLanguage.Text.Styles.NavBarExpandedTitle
  }, title), !isSubtextFirst && /*#__PURE__*/_react["default"].createElement(_designLanguage.Text, {
    color: _designLanguage.Text.Colors.TextTertiary,
    textAlign: textAlign,
    styles: shouldRenderTitleOnNewLine && !displayTitleBelow ? _designLanguage.Text.Styles.NavBarCollapsedSubtitle : _designLanguage.Text.Styles.NavBarExpandedSubtitle
  }, displaySubtext))), isSeparatorVisible && /*#__PURE__*/_react["default"].createElement(_componentSeparator["default"], {
    type: _componentSeparator["default"].Types.FullBorder
  }));
};

NavBar.propTypes = {
  isRaised: _propTypes["default"].bool,
  isSeparatorVisible: _propTypes["default"].bool,
  navigationType: _propTypes["default"].oneOf(Object.values(_constants.NavigationTypes)),
  noContentPadding: _propTypes["default"].bool,
  title: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  titleSize: _propTypes["default"].oneOf(Object.values(_constants.TitleSizes)),
  shouldRenderTitleOnNewLine: _propTypes["default"].bool,
  parentTitle: _propTypes["default"].string,
  subtext: _propTypes["default"].string,
  onNavigationClick: _propTypes["default"].func,
  onOverflowClick: _propTypes["default"].func,
  maxNumberOfVisibleActions: _propTypes["default"].number,
  strings: _propTypes["default"].shape({
    navigationButtonLabel: _propTypes["default"].string
  }),
  textAlign: _propTypes["default"].oneOf([_designLanguage.Text.TextAlignments.Left, _designLanguage.Text.TextAlignments.Center]),
  actions: _propTypes["default"].arrayOf(_propTypes["default"].shape(_componentButton.IconButton.propTypes))
};
NavBar.defaultProps = {
  isRaised: false,
  onNavigationClick: function onNavigationClick() {},
  navigationType: _constants.NavigationTypes.Back,
  strings: {},
  maxNumberOfVisibleActions: 2,
  textAlign: _designLanguage.Text.TextAlignments.Left,
  titleSize: _constants.TitleSizes.Small
};
NavBar.TextAlignments = (0, _lodash["default"])(_designLanguage.Text.TextAlignments, ['Right', 'Justify']);
NavBar.TitleSizes = _constants.TitleSizes;
NavBar.NavigationTypes = _constants.NavigationTypes;
var _default = NavBar;
exports["default"] = _default;